import Details, { DetailsProps } from './Details';

export type { DetailsProps };
export default Details;
